import React, { ButtonHTMLAttributes } from 'react';
import { CloseIcon, resetButtonStyle } from '@kvdbil/components';
import styled from 'styled-components';
import { useTranslation } from '~/Locale';

const CloseIconBtn = styled.button<CloseProps>`
  ${resetButtonStyle}
  font-size: ${({ iconSize = 2 }) => `${iconSize}rem`};

  &:focus-visible {
    outline: revert;
  }
`;

type CloseProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  iconSize?: number;
};

export const Close = ({ ['aria-label']: ariaLabel, ...rest }: CloseProps) => {
  const { t } = useTranslation();
  return (
    <CloseIconBtn aria-label={ariaLabel ?? t('Close')} type="button" {...rest}>
      <CloseIcon />
    </CloseIconBtn>
  );
};
